import React from "react";
import { DashboardInfoField } from "components/dashboard/info-field";
import { useProject } from "@/modules/work/projects/context";
import { Badge } from "ui/components/badge";

export default function TagsSection() {
  const { data } = useProject();
  const tags = Array.isArray(data?.tags) ? data.tags : [];

  if (tags.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 px-4 md:px-6">
      {tags.map((t) => {
        const tag = t?.tag ?? t;
        if (!tag?.label) return null;
        return (
          <Badge key={tag.id} variant="outline">
            {tag.label}
          </Badge>
        );
      })}
    </div>
  );
}
